import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme } from 'styles';
import { iconCartSvg, iconCloseSvg } from 'images';

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.sp.l};
  border-bottom: 1px solid ${theme.colors.border};
  padding: ${theme.sp.m} 0;
  height: 60px;
  text-transform: uppercase;
`;

const CartIconWrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
`;

const CartIcon = styled.img`
  margin-right: 10px;
`;

const CloseButton = styled.button`
  img {
    width: 16px;
  }
`;

const propTypes = {
  onClose: PropTypes.func.isRequired,
  quantity: PropTypes.number.isRequired,
};

function Header({ onClose, quantity }) {
  return (
    <StyledHeader>
      <CartIconWrapper>
        <CartIcon src={iconCartSvg} alt="Cart" />
        {quantity} items
      </CartIconWrapper>
      <CloseButton onClick={onClose}>
        <img src={iconCloseSvg} alt="Close" />
      </CloseButton>
    </StyledHeader>
  );
}

Header.propTypes = propTypes;

export default Header;



// WEBPACK FOOTER //
// ./src/components/shared/CartDrawer/components/Header.jsx